var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCsvLoadFail = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 16,
  viewBox: "0 0 12 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.33333 0.666672H8.27614L12 4.39053V14C12 14.7364 11.403 15.3333 10.6667 15.3333H1.33333C0.596954 15.3333 0 14.7364 0 14V2.00001C0 1.26363 0.596954 0.666672 1.33333 0.666672ZM6.66667 2.00001H1.33333V14H10.6667V6H8C7.26362 6 6.66667 5.40305 6.66667 4.66667V2.00001ZM8 2.27615V4.66667H10.3905L8 2.27615ZM3.52857 7.80472L4.47138 6.86191L5.99998 8.3905L7.52857 6.86191L8.47138 7.80472L6.94278 9.33331L8.47138 10.8619L7.52857 11.8047L5.99998 10.2761L4.47138 11.8047L3.52857 10.8619L5.05717 9.33331L3.52857 7.80472Z",
  fill: "#EE6363"
})));
export { SvgCsvLoadFail as ReactComponent };
export default __webpack_public_path__ + "6dc7e129776aa38cb8405d49843dc006.svg";